import Swiper from 'swiper';
import { A11y, FreeMode } from 'swiper/modules';
import { animate } from '../../core/animations';
import productTileTemplate from '../collection/productTileTemplateNosto';
import { initSelectNewColor } from '../collection/selectNewColor';
import { initProductsCarouselModal, getProductsModal } from './products-carousel-modal';
// import { formatProductPrices } from '../../core/helpers';
import sliderADA from '../../components/slider/ada';
import { selectSwatch } from '../collection/selectNewColor';

/* Data example:
<script type="application/json" data-products-carousel-json="1589751878206">
{
  "slides": [{
      "index": 1,
      "products": ["3-4-sleeve-cinch-waist-floral-dress","3d-basketweave-knit-sweater"]
    },{
      "index": 2,
      "products": ["agnes-top"]
    },{
      "index": 3,
      "products": []
    },{
      "index": 4,
      "products": ["aja-floral-long-sleeved-dress","alana-dress"]
    },{
      "index": 5,
      "products": []
    }]
}
</script>
*/

// Avoid showing incorect products on slide change, this can happen when a product loads after going to another slide
let current_products = [];
let current_products_modal = [];

// Used to destroy the slider when closing the modal
let swiper = null;

const loadProduct = (product_handle, block_id, product_index) => {
  const store_domain = (window.location.origin.indexOf('myshopify.com') !== -1 || window.location.origin.indexOf('localhost') !== -1) ? `https://${Shopify.shop}` : window.location.origin;

  $.ajax({
    url: `${store_domain}/products/${product_handle}?view=json`,
    method: 'get',
  }).done((json) => {
    const product_json = JSON.parse(json);
    // console.log(product_json);
    product_json.swatches = `<div class="color-swatches" data-color-swatches>${product_json.swatches}</div>`;

    const is_modal = ($(`[data-block-id="${block_id}"][data-gallery-products-modal]`).length !== 0);

    // It doesn't matter if it's from the modal or not
    window.theme.lookbook_products.push(product_json);

    // const formatted_products = formatProductPrices([product_json], true);

    // const products_tiles_html = compiled({ products: formatted_products, is_lookbook: true, quickview: false, is_search: false });

    const products_tiles_html = [product_json].map((product) => productTileTemplate(product, {
      is_slider: false,
      is_simplified: true,
      has_swatches: true,
      has_quickview: true,
      is_search: false,
      is_lookbook: true,
      enable_price_conversion: false,
      has_animations: false
    })).join('');


    // Remove the loader
    // if ($(`[data-block-id="${block_id}"] [data-gallery-products-items] [data-product-tile]`).length === 0) {
    //   $(`[data-block-id="${block_id}"] [data-gallery-products-items]`).html('');
    // }

    let products_container = `[data-block-id="${block_id}"] [data-gallery-products-items]`;

    if (is_modal) {
      if (current_products_modal.indexOf(product_json.handle) === -1) {
        return;
      }

      products_container = `[data-block-id="${block_id}"] [data-gallery-products-modal-items]`;
    } else if (current_products.indexOf(product_json.handle) === -1) {
      return;
    }

    // Only 2 products for now
    if (product_index === 0) {
      $(products_container).prepend(products_tiles_html);
    } else {
      $(products_container).append(products_tiles_html);
    }

    // Preselect the first color
    document.querySelectorAll('[data-product-tile]').forEach(tile => {
      const activeSwatch = tile.querySelector('[data-color-swatch].active');
      if (!activeSwatch) {
        const firstSwatch = tile.querySelector('[data-color-swatch]');
        if (firstSwatch) {
          selectSwatch(firstSwatch);
          // Optionally: tile.querySelector('[data-add-to-cart-alt-button]')?.classList.remove('active');
        }
      }
    });

    animate();

    // if (window.theme.isZonos && typeof zonos !== 'undefined') {
    //   window.setTimeout(() => {
    //     zonos.displayCurrency();
    //   }, 1);
    // }
  });
};

const loadSlideProducts = (slide_i, block_id) => {
  let product_handles = [];
  const modal_element = document.querySelector(`[data-block-id="${block_id}"][data-gallery-products-modal]`);

  if (modal_element) {
    current_products_modal = getProductsModal(slide_i, block_id);
    product_handles = current_products_modal;
  }

  if (modal_element === null || !product_handles.length) {
    const block_json = JSON.parse(document.querySelector(`[data-products-carousel-json="${block_id}"]`).textContent).slides;
    current_products = block_json[0].products;
    product_handles = current_products;

    if (modal_element) {
      current_products_modal = current_products;
    }
  }

  product_handles.forEach((product_handle, i) => {
    loadProduct(product_handle, block_id, i);
  });
};

const destroyProductSwiperCarousel = () => {
  if (swiper) {
    swiper.destroy(true, true);
    swiper = null;
  } else {
    console.warn('[ProductsCarousel] Swiper instance is not initialized.');
  }
};

const initProductSwiperCarousel = (slider, selected_slide = 1, block_id_param = null) => {
  let is_init = false;
  swiper = new Swiper(slider, {
    modules: [ A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    loopAddBlankSlides: false,
    autoHeight: true,
    freeMode: false,
    autoplay: false,
    initialSlide: selected_slide - 1,
    on: {
      init: function () {
        window.dispatchEvent(new Event('resize'));
        const block_id = (block_id_param === null) ? $(slider).closest('.gallery-products-carousel').data('block-id') : block_id_param;
        $(`[data-block-id="${block_id}"] [data-gallery-products-items]`).empty();
        $(`[data-block-id="${block_id}"] [data-gallery-products-modal-items]`).empty();
        loadSlideProducts(selected_slide - 1, block_id);
        sliderADA(slider);
      },
      slideChangeTransitionStart: function (swiper) {
        // This event + init gets called if the initial slide is not 0
        if (selected_slide - 1 === swiper.realIndex && !is_init) {
          return;
        }

        is_init = true;
        const block_id = (block_id_param === null) ? $(slider).closest('.gallery-products-carousel').data('block-id') : block_id_param;
        $(`[data-block-id="${block_id}"] [data-gallery-products-items]`).empty();
        $(`[data-block-id="${block_id}"] [data-gallery-products-modal-items]`).empty();
        loadSlideProducts(swiper.realIndex, block_id);
      },
    }
  });
};

const initProductsCarousel = () => {
  const $product_sliders = $('[data-gallery-products-carousel-items]');

  // Regular "product carousel" sections
  if ($product_sliders.length) {
    $product_sliders.each(function() {
      initProductSwiperCarousel(this);
    });
  }

  // Open images sections in modal
  initProductsCarouselModal();

  // let products_carousels_init = 0;

  window.theme.lookbook_products = [];

  // Enable click on swatches
  initSelectNewColor();
};

export {
  initProductsCarousel,
  initProductSwiperCarousel,
  destroyProductSwiperCarousel,
};
